import { HeroStatistics } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { GetHeroStatisticsModel } from './C52HeroStatistics.service';
import { C52HeroStatisticsProps } from './C52HeroStatistics.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C52HeroStatisticsProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  const model = GetHeroStatisticsModel(props);

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName="HeroStatistics">
        <HeroStatistics
          id={props?.params?.AnchorLinkTargetName}
          className={translationClasses(props.params)}
          {...model}
        />
      </SwitchToPreviewMessage>
    );
  }

  return (
    <HeroStatistics
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props.params)}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};
